import { render, staticRenderFns } from "./null-data.vue?vue&type=template&id=5ea272d2&scoped=true&"
import script from "./null-data.vue?vue&type=script&lang=js&"
export * from "./null-data.vue?vue&type=script&lang=js&"
import style0 from "./null-data.vue?vue&type=style&index=0&id=5ea272d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea272d2",
  null
  
)

export default component.exports